export enum WorkerOperationState {
  InProgress,
  Succeeded,
  Failed,
  Canceled,
}

export function isCanceledError(error: Error) {
  return error.message === 'Canceled';
}

export function makeCanceledError(): Error {
  return new Error('Canceled');
}
